const bodyScrollLock = require('body-scroll-lock');

$(document).on('input', '.payout-commission-input', function() {
    let that = $(this),
        commission = that.data('commission'),
        value = $.trim(that.val()),
        hint = $('.payout-commission-hint'),
        counter = $('.payout-commission-counter'),
        count = value - parseInt(commission);

    if (value.length > 0 && count >= 0) {
        counter.text(count);
        hint.addClass('active');
    } else {
        hint.removeClass('active');
    }
});

$(document).on('click', '.request-open-popup', function () {
    openPopup();
})

function openPopup() {
    let element = document.querySelector('.bn_commerce-payout-request__popup-scroll');

    bodyScrollLock.disableBodyScroll(element, {reserveScrollBarGap: true});

    $('.bn_commerce-payout-request__popup-overlay').addClass('open');

    $('body').addClass('modal-open');
}

function closePopup () {
    $('.bn_commerce-payout-request__popup-overlay').removeClass('open');

    bodyScrollLock.clearAllBodyScrollLocks();

    $('body').removeClass('modal-open');
}

$(document).on('click', '.request-close-popup', function () {
    closePopup();
});

$(document).on('click', '.bn_commerce-payout-request__popup-submit', function () {
    let that = $(this),
        selector = '.bn_commerce-payout-request__content-form',
        sign = $('.bn_commerce-payout-request__popup-input-sign').val(),
        code = $('.bn_commerce-payout-request__popup-input-value').val(),
        error = $('.bn_commerce-payout-request__popup-error'),
        form = $(selector),
        formData = new FormData(document.querySelector(selector));

    error.html('');

    $.ajax({
        url: '/account/commerce/payouts/verify',
        type: 'POST',
        dataType: 'json',
        data: {
            code: code,
            sign: sign,
        },
        success: function (response) {
            if (response.success === false) {
                error.html(response.error);

                that.prop('disabled', false).removeClass('spin');
            } else {
                $.ajax({
                    url: form.attr('action'),
                    type: 'POST',
                    dataType: 'json',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        window.location.href = response.redirect;
                    }
                });
            }
        }
    });
});

$(document).on('click', '.bn_commerce-payout-request__popup-resend', function () {
    let sign = $('.bn_commerce-payout-request__popup-input-sign').val(),
        code = $('.bn_commerce-payout-request__popup-input-value').val();

    $.ajax({
        url: '/account/commerce/payouts/resend-sms',
        type: 'POST',
        dataType: 'json',
        data: {
            sign: sign,
            code: code,
        },
        success: function () {
            $('.bn_commerce-payout-request__popup-resend').hide();
            $('.bn_commerce-payout-request__popup-timer').show();

            $('.bn_commerce-payout-request__popup-timer-value').data('seconds', 60);

            countDown();
        }
    });
})

$(document).ready(function () {
    if ($('.bn_commerce-payout-request__popup-timer-value').length) {
        countDown();
    }
})

function countDown() {
    let selector = $('.bn_commerce-payout-request__popup-timer-value'),
        milliseconds = selector.data('seconds') * 1000,
        end = new Date(Date.now() + milliseconds + 200),
        timer;

    tick();

    function addZero(i) {
        if (i < 10) {i = "0" + i}
        return i;
    }

    function formatTime(time){
        let minutes = addZero(time.getMinutes()),
            seconds = addZero(time.getSeconds());

        return minutes + ":" + seconds;
    }

    function tick() {
        let remaining = new Date(end - Date.now());

        if (remaining > 0) {
            selector.html(formatTime(remaining));
            timer = setTimeout(tick, 1000);
        } else {
            clearInterval(timer);

            $('.bn_commerce-payout-request__popup-timer').hide();
            $('.bn_commerce-payout-request__popup-resend').show();
        }
    }
}